import { Injectable } from '@angular/core';
import {
  HttpInterceptor,
  HttpRequest,
  HttpHandler,
  HttpEvent,
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { NO_OFFLINE_QUEUE } from '@shared';

/**
 * User app policy (Option A):
 * - Never queue non-GET requests when offline.
 *
 * Rationale:
 * The shared OfflineInterceptor returns HTTP 202 "Queued" for offline non-GETs.
 * Many user-app flows (orders/payments/etc) expect a real server response immediately,
 * so queueing would create fake successes and break the UX.
 *
 * This interceptor marks non-GET requests with a header that the shared OfflineInterceptor
 * respects to disable queueing and fail fast with an offline error.
 */
@Injectable()
export class NoOfflineQueueInterceptor implements HttpInterceptor {
  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const method = req.method.toUpperCase();
    if (method === 'GET') {
      return next.handle(req);
    }

    return next.handle(
      req.clone({
        context: req.context.set(NO_OFFLINE_QUEUE, true),
      }),
    );
  }
}

